import { z } from 'zod';

export const coursesControllerCreate201Schema = z.string();

export const coursesControllerCreate400Schema = z.union([
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['ForeignViolation']),
    details: z.object({ attributes: z.array(z.string()) }),
  }),
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['InvalidData']),
    details: z.object({
      location: z.enum(['path', 'query', 'body']),
      explanation: z.object({
        issues: z.array(
          z
            .object({
              code: z.enum([
                'invalid_type',
                'invalid_literal',
                'custom',
                'invalid_union',
                'invalid_union_discriminator',
                'invalid_enum_value',
                'unrecognized_keys',
                'invalid_arguments',
                'invalid_return_type',
                'invalid_date',
                'invalid_string',
                'too_small',
                'too_big',
                'invalid_intersection_types',
                'not_multiple_of',
                'not_finite',
              ]),
              path: z.array(z.union([z.string(), z.number()])),
              message: z.string(),
            })
            .catchall(z.unknown()),
        ),
      }),
    }),
  }),
]);

export const coursesControllerCreate401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const coursesControllerCreate403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const coursesControllerCreateMutationRequestSchema = z.object({
  title: z.string().min(3).max(255),
  isPublic: z.boolean().default(true).optional(),
  description: z.string().min(3).max(255).optional().nullable(),
  cover: z.string().optional().nullable(),
});

export const coursesControllerCreateMutationResponseSchema = z.string();
